import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  [x: string]: any;
  open: boolean;
  userDetails: {};
}

const initialState: InitialState = {
  open: true,
  userDetails: {}
};

const appLayoutSlice = createSlice({
  name: 'appLayout',
  initialState,
  reducers: {
    toggleSidebar(state: InitialState) {
      state.open = !state.open;
    },
    setUserDetails(state: InitialState, action) {
      state.userDetails = { ...state.userDetails, ...action.payload };
    },
    resetUserDetails(state: InitialState) {
      state.userDetails = {};
    }
  },
});

export const { actions, reducer } = appLayoutSlice;
export default appLayoutSlice;